// extracted by mini-css-extract-plugin
module.exports = {"header":"MainSection_header__9UP9f","section":"MainSection_section__fhmOV"};